export const UPLOAD_FILE_TAB = {
  FROM_MY_DRIVE: 0,
  FROM_COMPUTER: 1
};
